export default __webpack_public_path__ + "static/dwp-digital-65b50a435d3313ff6ad7dcb8fafb41e5.png";